<template>
  <section>
    <v-container>
      <v-row>
        <v-col
          v-for="legalNew in legalNews"
          :key="legalNew.name + legalNew.date"
          cols="3"
        >
          <news-card :legalNew="legalNew" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    components: {
      NewsCard: () => import('@/components/NewsCard.vue')
    },
    data: () => ({
      legalNews: [
        { name: 'Sed ut perspiciatis unde omnis', date: '09-02-2020', img: '/static/glenn-carstens-peters-npxXWgQ33ZQ-unsplash.jpg' },
        { name: 'At vero eos et accusamus et iusto', date: '09-02-2020', img: '/static/glenn-carstens-peters-npxXWgQ33ZQ-unsplash.jpg' },
        { name: 'Nam libero tempore, cum soluta', date: '09-02-2020', img: '/static/glenn-carstens-peters-npxXWgQ33ZQ-unsplash.jpg' },
        { name: 'Itaque earum rerum hic tenetur', date: '09-02-2020', img: '/static/glenn-carstens-peters-npxXWgQ33ZQ-unsplash.jpg' }
      ]
    })
  }
</script>
